module.exports = __webpack_public_path__ + "static/media/Capacidad60.bbd442dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/Capacidad60.svg
// module id = 156
// module chunks = 0